import request from 'api/index'

//退出登录

export function mylogout(query) {
  return request({
    url: '/api/user/logout',
    method: 'get',
    query
  })
}
//获取用户信息
export function getuser(query) {
  return request({
    url: '/api/user/getuserinfo',
    method: 'get',
    query
  })
}
//获取短信验证码
export function getcode(params) {
  return request({
    url: '/api/user/sendsms',
    method: 'get',
    params
  })
}

//验证短信验证码
export function checkcode(params) {
  return request({
    url: '/api/user/checksms',
    method: 'get',
    params
  })
}
//申请使用
export function applyusing(query) {
  return request({
    url: '/api/user/Apply',
    method: 'get',
    query
  })
}

//传入登录类型
export function submitType(query) {
  return request({
    url: '/api/user/setsystemtype',
    method: 'get',
    query
  })
}

//清除用户信息
export function clearUserInfo() {
  return request({
    url: '/api/user/clearuserinfo',
    method: 'get',
  })
}
